import React, { useState, useEffect, useCallback } from 'react';
import {
  CheckCircle,
  Cancel,
  Person,
  CreditCard,
  Camera,
  Description,
  Visibility,
  Download,
  Phone,
  AccountBalance,
  Security,
  Timer,
} from '@mui/icons-material';
import ChecklistIcon from '@mui/icons-material/Checklist';
import EmergencyRecordingIcon from '@mui/icons-material/EmergencyRecording';
import './AutoApprovalDashboard.scss';
import Loader from '../../../../presentationals/Loader/Loader.component'
import { getApprovalChecksForLoanIdByUserid, getAutoLoanOfferById, getAnalysercheckByUseRIdNew } from '../../AdminActionCreator.component';
import { APIS } from '../../../../../utils/api-factory';

const KYCVerificationDashboard = ({ allDetail, customHeaderTenant }) => {
  const [activeTab, setActiveTab] = useState('overview');
  const [loader, setLoader] = useState(false);
  const [kycData, setkycData] = useState({});
  const [currentActiveImageView, setcurrentActiveImageView] = useState('selfieImage')
  const [loanOfferData, setLoanOfferData] = useState({ show: false, data: {} })
  const [selectedchecklistview, setSelectedchecklsitView] = useState('nameCheck')
  const [repeatUser, setRepeatUser] = useState(false);
  const [repeatLoanOfferSelectedView, setRepeatLoanOfferSelectedView] = useState("")

  const [smsBankStatemnetcheck, setSmsBankStatementcheck] = useState([])
  const [currentActiveTab, setcurrentActiveTab] = useState("smsSource")

  useEffect(() => {
    checkRepeatUser()
    getAnalysercheckByUseRIdFn()
  }, [])

  const checkRepeatUser = () => {
    fetch(APIS.CHECK_REPEAT_USER + allDetail.userId)
      .then(res => res.json())
      .then(res => {
        setRepeatUser(res.repeatUser)
        getApprovalChecksForLoanIdByUseridFn(res.repeatUser)
      })
  }

  const getApprovalChecksForLoanIdByUseridFn = (userType) => {
    setLoader(true)
    getApprovalChecksForLoanIdByUserid(allDetail?.userId, callback => {
      console.log("ca", callback)
      if (callback?.status == 200 && callback?.message == "success") {
        setkycData(callback)
        if (callback?.data?.overallStatus == "PASSED" || userType == true) {
          getAutoLoanOfferByIdFn()
        }
      } else {
        setkycData({})
      }
      setLoader(false)
    })
  }

  const getAutoLoanOfferByIdFn = () => {
    setLoader(true)
    getAutoLoanOfferById(allDetail?.userId, callback => {
      console.log("ca", callback)
      setLoanOfferData({ show: true, data: callback })
      setLoader(false)
    })
  }
  const getAnalysercheckByUseRIdFn = () => {
    setLoader(true)
    getAnalysercheckByUseRIdNew(allDetail,customHeaderTenant, callback => {
      if (callback?.status == 200 && callback?.message == "success" && callback?.data?.length > 0) {
        setSmsBankStatementcheck(callback?.data)
      } else {
        setSmsBankStatementcheck([])
      }
      setLoader(false)
    })
  }

  const getCustomCheckStatusByTab = (currentTab, checkType) => {

    if (!smsBankStatemnetcheck || smsBankStatemnetcheck?.length === 0) {
      return 'FAILED';
    }

    const policyData = smsBankStatemnetcheck.find((el) => el?.policyName === checkType.toUpperCase());

    if (!policyData) {
      console.log('No policy data found for:', checkType);
      return 'FAILED';
    }


    const sourceData = policyData[currentTab];

    const decision = sourceData?.decision;


    if (!decision) {

      return 'FAILED';
    }

    const passedDecisions = ['GREEN', 'PASSED', 'SUCCESS', 'TRUE'];
    const failedDecisions = ['FALSE', 'FAILED', 'RED'];

    if (passedDecisions.includes(decision.toUpperCase())) {

      return 'PASSED';
    }
    if (failedDecisions.includes(decision.toUpperCase())) {

      return 'FAILED';
    }

    return 'FAILED';
  };

  const getTableData = (selectedchecklistview, currentActiveTab) => {
    const data = smsBankStatemnetcheck?.find((el) => el?.policyName == selectedchecklistview?.toUpperCase())
    const finalData = data?.[currentActiveTab] !== null && data?.[currentActiveTab] !== undefined && data?.[currentActiveTab] !== "" && Object?.keys(data?.[currentActiveTab])?.length > 0 ? data?.[currentActiveTab] : {}
    return finalData
  }

  const handlecurrentActiveTab = (value) => {
    setcurrentActiveTab(value)
  }

  const StatusIcon = ({ status }) => {
    return status === "PASSED" ? (
      <CheckCircle className="status-icon status-icon--success" />
    ) : (
      <Cancel className="status-icon status-icon--error" />
    );
  };

  const StatusBadge = ({ status, text }) => {
    return (
      <span className={`status-badge-auto status-badge-auto--${status === "PASSED" ? "success" : "error"}`}>
        <StatusIcon status={status} />
        {text}
      </span>
    );
  };

  const tabs = [
    { id: 'overview', label: 'Overview', icon: <Description fontSize="small" /> },
    { id: 'checklist', label: 'Checklist', icon: <ChecklistIcon fontSize="small" /> },
    { id: 'loanOffer', label: 'Loan Offer', icon: <EmergencyRecordingIcon fontSize="small" /> },
  ];

  const checklistchecks = [
    { id: 'nameCheck', label: 'Name Verification' },
    { id: 'panAadhar', label: 'PAN-Aadhaar Link' },
    { id: 'faceMatch', label: 'Face Match' },
    { id: 'mobileReferenceUniqueness', label: 'Mobile Reference Uniqueness' },
    { id: 'upiAutopayCheck', label: 'UPI Autopay Check' },
    { id: 'bankAccountMatch', label: 'Bank Account Match' },
    { id: 'mobileNumberAgeCheck', label: 'Mobile Number Age Check' },
    { id: 'emi', label: 'EMI' },
    { id: 'overdue', label: 'Overdue' },
    { id: 'salary', label: 'Salary' },
  ]

  const renderOverview = () => (
    <div className="row">
      <div className="col-lg-4 col-md-6 " style={{ marginBottom: '20px' }}>
        <div className="overview-item">
          <div className="overview-item-header">
            <div className="overview-item-title">PAN-Aadhaar Linkage</div>
            <StatusBadge status={kycData?.data?.panAadhaarLink?.status} text={kycData?.data?.panAadhaarLink?.status} />
          </div>
          <div className="overview-item-description">
            Verification of PAN and Aadhaar linkage status
          </div>
        </div>
      </div>

      <div className="col-lg-4 col-md-6 " style={{ marginBottom: '20px' }}>
        <div className="overview-item">
          <div className="overview-item-header">
            <div className="overview-item-title">Name Verification</div>
            <StatusBadge status={kycData?.data?.nameCheck?.status} text={kycData?.data?.nameCheck?.status} />
          </div>
          <div className="overview-item-description">
            Cross-verification of names across Aadhaar, PAN, App, and Bank records
          </div>
        </div>
      </div>

      <div className="col-lg-4 col-md-6 " style={{ marginBottom: '20px' }}>
        <div className="overview-item">
          <div className="overview-item-header">
            <div className="overview-item-title">Face Match</div>
            <StatusBadge
              status={kycData?.data?.faceMatch ? (kycData?.data?.faceMatch?.verified ? "PASSED" : "FAILED") : "FAILED"}
              text={kycData?.data?.faceMatch ? (kycData?.data?.faceMatch?.verified ? "PASSED" : "FAILED") : "NOT AVAILABLE"}
            />
          </div>
          <div className="overview-item-description">
            Biometric verification {kycData?.data?.faceMatch?.matchPercentage ? `with ${kycData?.data?.faceMatch?.matchPercentage} match accuracy` : 'not available'}
          </div>
        </div>
      </div>

      <div className="col-lg-4 col-md-6 " style={{ marginBottom: '20px' }}>
        <div className="overview-item">
          <div className="overview-item-header">
            <div className="overview-item-title">Mobile Reference Uniqueness</div>
            <StatusBadge status={kycData?.data?.mobileReferenceUniqueness?.status} text={kycData?.data?.mobileReferenceUniqueness?.status} />
          </div>
          <div className="overview-item-description">
            Verification of mobile number uniqueness across references
          </div>
        </div>
      </div>

      <div className="col-lg-4 col-md-6 " style={{ marginBottom: '20px' }}>
        <div className="overview-item">
          <div className="overview-item-header">
            <div className="overview-item-title">UPI Autopay Check</div>
            <StatusBadge status={kycData?.data?.upiAutopayCheck?.status} text={kycData?.data?.upiAutopayCheck?.status} />
          </div>
          <div className="overview-item-description">
            {kycData?.data?.upiAutopayCheck?.message || "UPI Autopay setup verification"}
          </div>
        </div>
      </div>

      <div className="col-lg-4 col-md-6 " style={{ marginBottom: '20px' }}>
        <div className="overview-item">
          <div className="overview-item-header">
            <div className="overview-item-title">Bank Account Match</div>
            <StatusBadge status={kycData?.data?.bankAccountMatch?.status} text={kycData?.data?.bankAccountMatch?.status} />
          </div>
          <div className="overview-item-description">
            Verification of bank account details matching
          </div>
        </div>
      </div>
    </div>
  );

  const renderNameCheck = () => (
    <div className="row">
      <div className="col-lg-6 col-md-6" style={{ marginBottom: '15px' }}>
        <div className="name-item">
          <div className="name-item-label">Aadhaar Name</div>
          <div className="name-item-value">{kycData?.data?.nameCheck?.nameFromAadhar || "-"}</div>
        </div>
      </div>
      <div className="col-lg-6 col-md-6" style={{ marginBottom: '15px' }}>
        <div className="name-item">
          <div className="name-item-label">PAN Name</div>
          <div className="name-item-value">{kycData?.data?.nameCheck?.nameFromPan || "-"}</div>
        </div>
      </div>
      <div className="col-lg-6 col-md-6" style={{ marginBottom: '15px' }}>
        <div className="name-item">
          <div className="name-item-label">App Name</div>
          <div className="name-item-value">{kycData?.data?.nameCheck?.nameFromApp || "-"}</div>
        </div>
      </div>
      <div className="col-lg-6 col-md-6" style={{ marginBottom: '15px' }}>
        <div className="name-item">
          <div className="name-item-label">Bank Name</div>
          <div className="name-item-value">{kycData?.data?.nameCheck?.nameFromBank || "-"}</div>
        </div>
      </div>
    </div>
  );

  const renderPanAadhar = () => (
    <div className="row">
      <div className="col-12">
        <div className="pan-aadhar-content">
          <CreditCard className="pan-aadhar-icon" />
          <div className="pan-aadhar-title">PAN-Aadhaar Link Verified</div>
          <div className="pan-aadhar-description">
            The PAN and Aadhaar linkage has been successfully verified and is compliant with regulatory requirements.
          </div>
        </div>
      </div>
    </div>
  );

  const renderFaceMatch = () => (
    <div className="row">
      <div className="col-lg-6 mb-4">
        <div className="face-match-info">
          {kycData?.data?.faceMatch ? (
            <>
              <div className={`match-percentage ${kycData?.data?.faceMatch?.verified == true ? "" : "color-red"}`}>
                {kycData?.data?.faceMatch?.matchPercentage || "0"}
              </div>
              <div className={`verification-message ${kycData?.data?.faceMatch?.verified == true ? "" : "color-red"}`}>
                {kycData?.data?.faceMatch?.verificationMessage || "-"}
              </div>
              <div className="name-item mb-3">
                <div className="name-item-label">Status Code</div>
                <div className="name-item-value">{kycData?.data?.faceMatch?.statusCode || "-"}</div>
              </div>
              <div className="name-item">
                <div className="name-item-label">Status Message</div>
                <div className="name-item-value">{kycData?.data?.faceMatch?.statusMessage || "-"}</div>
              </div>
            </>
          ) : (
            <div className="verification-message color-red">
              Face match data is not available
            </div>
          )}
        </div>
      </div>
      <div className="col-lg-6">
        <div className="image-section">
          <div className="image-placeholder">
            {kycData?.data?.faceMatch?.[currentActiveImageView] !== "" && kycData?.data?.faceMatch?.[currentActiveImageView] ? (
              <img src={"data:image/png;base64," + kycData?.data?.faceMatch?.[currentActiveImageView]} />
            ) : (
              <Camera style={{ fontSize: '48px' }} />
            )}
          </div>
          <div className="image-actions">
            <button
              className={`image-action-btn ${currentActiveImageView == "selfieImage" ? "active" : ""}`}
              onClick={(e) => setcurrentActiveImageView("selfieImage")}
              disabled={!kycData?.data?.faceMatch}
            >
              <Visibility fontSize="small" />
              View Selfie
            </button>
            <button
              className={`image-action-btn ${currentActiveImageView == "poiImage" ? "active" : ""}`}
              onClick={(e) => setcurrentActiveImageView("poiImage")}
              disabled={!kycData?.data?.faceMatch}
            >
              <Visibility fontSize="small" />
              View POI
            </button>
          </div>
        </div>
      </div>
    </div>
  );

  const renderMobileReferenceUniqueness = () => (
    <div className="row">
      <div className="col-lg-6">
        <div className="name-item mb-3">
          <div className="name-item-label">Primary Mobile</div>
          <div className="name-item-value">{kycData?.data?.mobileReferenceUniqueness?.primaryMobile || "-"}</div>
        </div>
        <div className="name-item" style={{ marginTop: '10px' }}>
          <div className="name-item-label">Reference Numbers</div>
          <div className="name-item-value">
            {kycData?.data?.mobileReferenceUniqueness?.referenceNumbers?.length > 0
              ? kycData?.data?.mobileReferenceUniqueness?.referenceNumbers?.join(',  ')
              : "No reference numbers found"
            }
          </div>
        </div>
      </div>
      <div className="col-lg-6">
        <div className="pan-aadhar-content">
          <Phone className="pan-aadhar-icon" style={{ color: kycData?.data?.mobileReferenceUniqueness?.status == "PASSED" ? "#22c55e" : "#ef4444" }} />
          <div className="pan-aadhar-title">Mobile Reference Check</div>
          <div className="pan-aadhar-description">
            Mobile number uniqueness has been verified across all reference sources.
          </div>
        </div>
      </div>
    </div>
  );

  const renderUpiAutopayCheck = () => (
    <div className="row">
      <div className="col-12">
        <div className="pan-aadhar-content">
          <AccountBalance className="pan-aadhar-icon" style={{ color: kycData?.data?.upiAutopayCheck?.status == "PASSED" ? "#22c55e" : "#ef4444" }} />
          <div className="pan-aadhar-title">UPI Autopay Verification</div>
          <div className="pan-aadhar-description">
            {kycData?.data?.upiAutopayCheck?.message || "UPI Autopay setup verification completed successfully."}
          </div>
        </div>
      </div>
    </div>
  );

  const renderBankAccountMatch = () => (
    <div className="row">
      <div className="col-lg-6">
        <div className="name-item mb-3">
          <div className="name-item-label">Account from Info</div>
          <div className="name-item-value">{kycData?.data?.bankAccountMatch?.bankAccountFromAccountInfo || "-"}</div>
        </div>
        <div className="name-item" style={{ marginTop: '10px' }}>
          <div className="name-item-label">Account from Verification</div>
          <div className="name-item-value">{kycData?.data?.bankAccountMatch?.bankAccountFromVerification || "Not Available"}</div>
        </div>
      </div>
      <div className="col-lg-6">
        <div className="pan-aadhar-content">
          <AccountBalance className="pan-aadhar-icon" style={{ color: kycData?.data?.bankAccountMatch?.status == "PASSED" ? "#22c55e" : "#ef4444" }} />
          <div className="pan-aadhar-title">Bank Account Verification</div>
          <div className="pan-aadhar-description">
            {kycData?.data?.bankAccountMatch?.status === "PASSED"
              ? "Bank account details have been successfully matched and verified."
              : "Bank account verification failed or is incomplete."
            }
          </div>
        </div>
      </div>
    </div>
  );

  const renderMobileNumberAgeCheck = () => (
    <div className="row">
      <div className="col-12">
        <div className="pan-aadhar-content">
          <Timer className="pan-aadhar-icon" style={{ color: kycData?.data?.mobileNumberAgeCheck?.status == "PASSED" ? "#22c55e" : "#ef4444" }} />
          <div className="pan-aadhar-title">Mobile Number Age Check</div>
          <div className="pan-aadhar-description">
            {kycData?.data?.mobileNumberAgeCheck?.message || "Mobile number age verification completed successfully."}
          </div>
        </div>
      </div>
    </div>
  );
  const renderEmiTable = (tab, activeTab) => (
    <div className="row">
      <div className="col-sm-5">
        <div style={{ display: 'flex', background: 'rgb(230, 247, 255)', borderRadius: '8px', padding: '8px', justifyContent: 'center' }}>
          <div style={{ cursor: 'pointer', width: '100%', textAlign: 'center', padding: '8px', background: currentActiveTab == "smsSource" ? '#23a4cc' : "none", color: currentActiveTab == "smsSource" ? '#fff' : "#000", borderRadius: '8px' }} onClick={() => handlecurrentActiveTab("smsSource")}>SMS</div>
          <div style={{ cursor: 'pointer', width: '100%', textAlign: 'center', padding: '8px', background: currentActiveTab == "bsSource" ? '#23a4cc' : "none", color: currentActiveTab == "bsSource" ? '#fff' : "#000", borderRadius: '8px' }} onClick={() => handlecurrentActiveTab("bsSource")}>Bank Statement</div>
        </div>
      </div>
      <div className="col-xs-12" style={{ marginTop: '20px' }}>
        <div style={{ boxShadow: 'rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.1) 0px 4px 6px -4px', borderTopLeftRadius: '7.5px', borderTopRightRadius: '7.5px' }}>
          <div className="loan_table_new" style={{ border: '1px solid rgb(229, 231, 235)', height: 'auto', height: window.innerWidth > 1800 ? "400px" : '270px', overflowY: 'auto' }}>
            <table >
              <thead style={{ background: '#fff', position: 'sticky', top: '0' }}>
                <tr style={{ borderBottom: '1px solid rgb(229, 231, 235)' }}>
                  <th style={{ borderTopLeftRadius: '7.5px', borderBottom: '1px solid rgb(229, 231, 235)' }}>Date</th>
                  <th style={{ borderBottom: '1px solid rgb(229, 231, 235)' }}>Policy Value</th>
                  <th style={{ borderTopRightRadius: '7.5px', borderBottom: '1px solid rgb(229, 231, 235)' }}>Amount</th>
                </tr>
              </thead>
              <tbody>
                {Object.keys(smsBankStatemnetcheck)?.length > 0 ?
                  getTableData(tab, activeTab) && getTableData(tab, activeTab)?.policyVal?.length > 0 ?
                    getTableData(tab, activeTab)?.policyVal?.map((v, index) => (
                      <tr key={index} style={{ borderBottom: '1px solid rgb(229, 231, 235)' }}>
                        <td style={{ padding: '10px 16px' }}>{getTableData(tab, activeTab)?.date?.[index]}</td>
                        <td style={{ padding: '10px 16px', width: '300px', whiteSpace: 'wrap' }}>{v}</td>
                        <td style={{ padding: '10px 16px' }}>{getTableData(tab, activeTab)?.amount?.[index]}</td>
                      </tr>
                    )) : <tr><td colSpan="3" style={{ textAlign: 'center' }}>No data available</td></tr>
                  : <tr><td colSpan="3" style={{ textAlign: 'center' }}>No data available</td></tr>}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );

  const renderContent = () => {
    switch (activeTab) {
      case 'overview':
        return renderOverview();
      default:
        return renderOverview();
    }
  };

  const getCheckStatus = useCallback((checkId) => {
    switch (checkId) {
      case 'nameCheck':
        return kycData?.data?.nameCheck?.status;
      case 'panAadhar':
        return kycData?.data?.panAadhaarLink?.status;
      case 'faceMatch':
        return kycData?.data?.faceMatch ? (kycData?.data?.faceMatch?.verified ? "PASSED" : "FAILED") : "FAILED";
      case 'mobileReferenceUniqueness':
        return kycData?.data?.mobileReferenceUniqueness?.status;
      case 'upiAutopayCheck':
        return kycData?.data?.upiAutopayCheck?.status;
      case 'bankAccountMatch':
        return kycData?.data?.bankAccountMatch?.status;
      case 'mobileNumberAgeCheck':
        return kycData?.data?.mobileNumberAgeCheck?.status;
      case 'emi':
        return getCustomCheckStatusByTab(currentActiveTab, 'EMI');
      case 'overdue':
        return getCustomCheckStatusByTab(currentActiveTab, 'OVERDUE');
      case 'salary':
        return getCustomCheckStatusByTab(currentActiveTab, 'SALARY');
      default:
        return "PASSED";
    }
  }, [currentActiveTab, smsBankStatemnetcheck, kycData]);

  const getCheckStatusText = useCallback((checkId) => {
    switch (checkId) {
      case 'nameCheck':
        return kycData?.data?.nameCheck?.status;
      case 'panAadhar':
        return kycData?.data?.panAadhaarLink?.status;
      case 'faceMatch':
        return kycData?.data?.faceMatch ? (kycData?.data?.faceMatch?.verified ? "PASSED" : "FAILED") : "NOT AVAILABLE";
      case 'mobileReferenceUniqueness':
        return kycData?.data?.mobileReferenceUniqueness?.status;
      case 'upiAutopayCheck':
        return kycData?.data?.upiAutopayCheck?.status;
      case 'bankAccountMatch':
        return kycData?.data?.bankAccountMatch?.status;
      case 'mobileNumberAgeCheck':
        return kycData?.data?.mobileNumberAgeCheck?.status;
      case 'emi':
        return getCustomCheckStatusByTab(currentActiveTab, 'EMI');
      case 'overdue':
        return getCustomCheckStatusByTab(currentActiveTab, 'OVERDUE');
      case 'salary':
        return getCustomCheckStatusByTab(currentActiveTab, 'SALARY');
      default:
        return "PASSED";
    }
  }, [currentActiveTab, smsBankStatemnetcheck, kycData]);

  const renderCheckContent = (checkId) => {
    switch (checkId) {
      case 'nameCheck':
        return renderNameCheck();
      case 'panAadhar':
        return renderPanAadhar();
      case 'faceMatch':
        return renderFaceMatch();
      case 'mobileReferenceUniqueness':
        return renderMobileReferenceUniqueness();
      case 'upiAutopayCheck':
        return renderUpiAutopayCheck();
      case 'bankAccountMatch':
        return renderBankAccountMatch();
      case 'mobileNumberAgeCheck':
        return renderMobileNumberAgeCheck();
      case 'emi':
      case 'overdue':
      case 'salary':
        return renderEmiTable(checkId, currentActiveTab);
      default:
        return '';
    }
  };

  const handleSelectedView = (id) => {
    setSelectedchecklsitView(selectedchecklistview == id ? "" : id)
  }

  const filterRepeatLoanAmount = () => {
    const repeatResponse = loanOfferData?.data?.repeatResponse;

    if (repeatResponse && Object.keys(repeatResponse).length > 0) {
      const matchedEntries = Object.entries(repeatResponse).filter(
        ([key, value]) => value?.matched === true
      );
      if (matchedEntries.length > 0) {

        return matchedEntries[0][1];
      }
    }

    return [];

  }

  useEffect(() => {
    const matched = filterRepeatLoanAmount();
    if (matched.length > 0) {
      setRepeatLoanOfferSelectedView(matched?.[0]?.[0]);
    }
  }, [loanOfferData]);

  return (
    <div className="kyc-dashboard" >
      {loader ? <Loader /> : ''}
      <div className="container-fluid" style={{ marginTop: '120px', padding: '0' }}>
        <div className="dashboard-header-auto">
          <div className="header-content">
            <h1 className="header-title">Auto Approval CheckList</h1>
            <div style={{ display: 'flex', gap: '10px' }}>
              <div className={`overall-status ${kycData?.data?.overallStatus === "PASSED" ? "" : "overall-status--failed"}`}>
                <StatusIcon status={kycData?.data?.overallStatus} />
                <span className="overall-status-text">
                  Overall Status: {kycData?.data?.overallStatus}
                </span>
              </div>
              {
                filterRepeatLoanAmount()?.offerAmount > 0 ?
                  <div className={`overall-status ${kycData?.data?.overallStatus === "PASSED" ? "" : "overall-status--failed"}`}>
                    <span className="overall-status-text">
                      Loan Offer: {repeatUser ? filterRepeatLoanAmount()?.offerAmount : (loanOfferData?.data?.freshResult?.offerAmount)?.toFixed(2)}
                    </span>
                  </div>
                  : ''}
            </div>
          </div>
        </div>

        <div className="tabs-container" style={{ justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', gap: '4px' }}>
            {tabs?.map((tab) => {
              if (tab?.id == "loanOffer" && loanOfferData?.show == false) return ""
              return (
                <button
                  key={tab.id}
                  className={`tab ${activeTab === tab?.id ? 'tab--active' : ''}`}
                  onClick={() => { setActiveTab(tab.id) }}
                >
                  {tab?.icon}
                  {/* {tab?.label} */}
                  {
                    tab?.id == "loanOffer" ? `${repeatUser ? "Repeat" : "Fresh"}` : tab.label
                  }
                </button>
              )
            })}
          </div>
        </div>

        {activeTab == "loanOffer" ? (
          <div className="content-card" style={{ marginTop: '25px' }}>
            {
              repeatUser ?
                ""
                :
                <div className="card-header">
                  <h2 className="card-title">
                    Fresh
                  </h2>

                  <StatusBadge
                    status={
                      loanOfferData?.data?.loanType == 'FRESH'
                        ? loanOfferData?.data?.freshResult?.approved == true ? "PASSED" : "Rejected"
                        : loanOfferData?.data?.repeatResult?.approved == true ? "PASSED" : "Rejected"
                    }
                    text={
                      loanOfferData?.data?.loanType == 'FRESH'
                        ? loanOfferData?.data?.freshResult?.approved == true ? "Approved" : "Rejected"
                        : loanOfferData?.data?.repeatResult?.approved == true ? "Approved" : "Rejected"
                    }
                  />

                </div>
            }

            {
              !repeatUser ?

                <div className="row">
                  <div className="col-12">
                    <div className="pan-aadhar-content">
                      <div>
                        <h2 style={{
                          fontSize: '40px ',
                          color: (loanOfferData?.data?.loanType == 'FRESH' && loanOfferData?.data?.freshResult?.offerAmount > 0) ||
                            (loanOfferData?.data?.loanType == 'REPEAT' && loanOfferData?.data?.repeatResult?.offerAmount > 0)
                            ? "#22c55e" : "red"
                        }}>
                          {loanOfferData?.data?.loanType == 'FRESH'
                            ? (loanOfferData?.data?.freshResult?.offerAmount)?.toFixed(2)
                            : (loanOfferData?.data?.repeatResult?.offerAmount)?.toFixed(2)
                          }
                        </h2>
                      </div>
                      <div className="pan-aadhar-description">
                        {loanOfferData?.data?.loanType == 'FRESH'
                          ? loanOfferData?.data?.freshResult?.message
                          : loanOfferData?.data?.repeatResult?.message
                        }
                      </div>
                    </div>
                  </div>
                </div>
                :
                <div className='row'>
                  <div className="col-xs-12">
                    <div className="" >
                      {
                        loanOfferData?.data?.repeatResponse !== null && Object.keys(loanOfferData?.data?.repeatResponse)?.length > 0 ? Object.keys(loanOfferData?.data?.repeatResponse)?.map((value, id) => {
                          if (loanOfferData?.data?.repeatResponse?.[value]?.matched !== true) return null
                          return (
                            <div style={{}} onClick={() => setRepeatLoanOfferSelectedView(value)}>
                              <div className="name-item-value" style={{ fontSize: '16px' }}>
                                {value == "closedWithin3DaysBeforeDueDate" ? "Closed Within 3 Days Before Due Date" : value == "threePreClosureAttemptsWithin3Days" ? "3 Pre-Closure Attempts Within 3 Days" : value == "preClosureAfter3DaysBeforeDueDate" ? "Pre-Closure After 3 Days Before Due Date" : value == "closedUpTo2DaysPostDueDate" ? "Closed Up to 2 Days Post Due Date" : value == "closedBetween3And10DPD" ? "Closed Between 3 and 10 DPD" : value == "closedAfter10DPD" ? "Closed After 10 DPD" : ""}
                              </div>
                              <hr />
                            </div>
                          )
                        })
                          : ''}
                    </div>
                  </div>
                  <div className="col-xs-12">
                   
                    {
                      loanOfferData?.data?.repeatResponse !== null && Object.keys(loanOfferData?.data?.repeatResponse)?.length > 0 ? Object.keys(loanOfferData?.data?.repeatResponse)?.map((value, id) => {
                        if (loanOfferData?.data?.repeatResponse?.[value]?.matched !== true) return null
                        return (
                          <div className="content-card" style={{ marginBottom: '24px', padding: '16px' }}>
                            <div className="pan-aadhar-content">
                              <div>
                                <h2 style={{
                                  fontSize: '40px ',
                                  color: loanOfferData?.data?.repeatResponse?.[value]?.offerAmount !== "" && loanOfferData?.data?.repeatResponse?.[value]?.offerAmount !== undefined && loanOfferData?.data?.repeatResponse?.[value]?.offerAmount !== null
                                    ? "#22c55e" : "red"
                                }}>
                                  {(loanOfferData?.data?.repeatResponse?.[value]?.offerAmount)?.toFixed(2) || 0}
                                </h2>
                              </div>
                              <div className="pan-aadhar-description">
                                {loanOfferData?.data?.repeatResponse?.[value]?.message}
                              </div>
                              {
                                loanOfferData?.data?.repeatResponse?.[value]?.reapplyDate !== null && loanOfferData?.data?.repeatResponse?.[value]?.reapplyDate !== undefined && loanOfferData?.data?.repeatResponse?.[value]?.reapplyDate !== "" ?
                                  <div className="pan-aadhar-description" style={{ fontSize: '14px' }}>
                                    You can Reapply for Loan on - {loanOfferData?.data?.repeatResponse?.[value]?.reapplyDate}
                                  </div>
                                  : ''}
                            </div>
                          </div>
                        )
                      })
                        : ''
                    }
                  </div>
                </div>
            }
          </div>
        ) : activeTab == "overview" ? (
          <div className="content-card">
            <div className="card-header">
              <h2 className="card-title">
                {tabs.find(tab => tab?.id === activeTab)?.label}
              </h2>
              <StatusBadge
                status={kycData?.data?.overallStatus}
                text={kycData?.data?.overallStatus}
              />
            </div>
            {renderContent()}
          </div>
        ) : activeTab == "checklist" ? (

          <div className="row">
            <div className="col-sm-3">
              <div className="content-card" style={{ marginBottom: '24px', padding: '16px', height: window.innerWidth > 1800 ? "750px" : '450px', overflowY: 'auto', scrollbarWidth: 'thin' }}>
                {
                  checklistchecks?.length > 0 ? checklistchecks?.map((value, id) => {
                    return (
                      <div className={`name-item ${selectedchecklistview == value?.id ? "active" : ""} `} style={{ padding: '12px', cursor: 'pointer', margin: '10px 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} onClick={() => handleSelectedView(value?.id)}>
                        <div className="name-item-value" style={{ fontSize: '12px' }}>
                          {value?.label}
                        </div>
                        {
                          value?.id == "emi" || value?.id == "overdue" || value?.id == "salary" ?
                            ""
                            :
                            <span >
                              <StatusIcon status={getCheckStatus(value?.id)} />
                            </span>
                        }
                      </div>
                    )
                  })
                    : ''}
              </div>
            </div>
            <div className="col-sm-9 col-xs-12">
              {
                checklistchecks?.length > 0 ? checklistchecks?.map((value, id) => {
                  if (value?.id !== selectedchecklistview) return ""
                  return (
                    <div className="content-card" key={id} style={{ marginBottom: '24px' }}>
                      <div className="card-header">
                        <h2 className="card-title">
                          {value?.label}
                        </h2>
                        {/* {
                          value?.id == "emi" || value?.id == "overdue" || value?.id == "salary" ? "" : */}
                        <StatusBadge
                          status={getCheckStatus(value?.id)}
                          text={getCheckStatusText(value?.id)}
                        />
                        {/* } */}
                      </div>
                      {renderCheckContent(value?.id)}
                    </div>
                  )
                }) : ''
              }
            </div>

          </div>
        ) : ''}
      </div>
    </div>
  );
};

export default KYCVerificationDashboard;